<style lang="less">
// .page-main-top {
//   .page-content {
//     height: 350px;
//   }
// }
.contentH .page-content {
  height: 350px;
}
</style>
<template>
  <div>
    <div class="page-main" v-loading="pageLoading">
      <div class="page-main-top">
        <el-row :gutter="20">
          <el-col :span="7" class="contentH">
            <information-list
              :list="basicInfo"
              :right="16"
              :left="8"
            ></information-list>
          </el-col>
          <el-col :span="17">
            <position-map :marker-point="markerPoint" :icon-status="iconStatus"></position-map>
          </el-col>
        </el-row>
      </div>
      <div class="page-main-bottom">
        <el-row :gutter="20">
          <el-col :span="24">
            <device :table-data="tableData" :station-id="id"></device>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import positionMap from "@/components/positionMap"; //地图信息
import informationList from "@/components/informationList"; //信息展示
import device from "@/components/device"; //设备信息
export default {
  name: "automaticStationList",
  components: {
    positionMap: positionMap,
    informationList: informationList,
    device: device
  },
  data() {
    return {
      pageLoading: true, //页面loading
      markerPoint: { lng: 116.404, lat: 39.915 },
      basicInfo: [
        {
          name: "自动站名称",
          attribute: "name",
          value: ""
        },
        {
          name: "位置",
          attribute: "address",
          value: ""
        },
        {
          name: "自动站描述",
          attribute: "desc",
          value: ""
        }
      ],

      tableData: [],
      iconStatus:0,
    };
  },
  computed: {
    id: function() {
      return this.$route.params.id || "";
    }
  },
  methods: {
    getDateil() {
      this.$$http("automaticStationInfo", {
        id: this.id
      })
        .then(results => {
          console.log("自动站信息", results);
          this.pageLoading = false;
          if (results.data && results.status == 200) {
            //坐标点
            this.markerPoint = { 
              lng: results.data.lng, 
              lat: results.data.lat
            };
            this.iconStatus = results.data.status;
            // console.log("坐标", this.markerPoint);
            //基本信息
            window.document.title = results.data.name ? results.data.name : "";
            for (let i in this.basicInfo) {
              this.basicInfo[i].value =
                results.data[this.basicInfo[i].attribute];
            }
            //设备列表
            this.tableData = results.data.devices;
            for (let i in this.tableData) {
              this.tableData[i].movableStr = this.pbFunc.isMovable(
                this.tableData[i].movable
              );
              this.tableData[i].statusObj = this.pbFunc.deviceState(
                this.tableData[i].status
              );
            }
            resolve(results);
          } else {
            this.$message.error(
              results.data.msg ? results.data.msg : "获取自动站信息失败"
            );
            reject(results);
          }
        })
        .catch(err => {
          this.pageLoading = false;
        });
    }
  },
  created() {
    this.getDateil();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/automaticStation/classify.vue